import { render } from "./Handler.vue?vue&type=template&id=abab4b3e&scoped=true"
import script from "./Handler.vue?vue&type=script&lang=js"
export * from "./Handler.vue?vue&type=script&lang=js"

import "./Handler.vue?vue&type=style&index=0&id=abab4b3e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-abab4b3e"

export default script